import { gql } from '@apollo/client';

export const CREATE_CAR_SALE = gql`
  mutation CreateCarSale($input: CreateCarSaleInput!) {
    createCarSale(createCarSaleInput: $input) {
      id
      dealerId
      carId
      buyer {
        name
        streetAddress
        city
        state
        zipcode
        phone
        email
        county
      }
      recordOfSaleNumber
      soldPrice
      docPrepFee
      smogFee
      salesTaxRate
      publicFees {
        vehicleLicenseFee
        registerTransferTitleFee
        tireFee
        subTotal
        totalDownPayment
        amountFinanced
        balance
      }
      tradeInVehicles {
        year
        make
        model
        vin
        odo
        agreedVal
        buyerRetainedEquity
        agreedValMinorsbuyerRetain
        priorCreditOrLeaseBal
        netTradeIn
      }
      cancellationPlan
      createdAt
      updatedAt
    }
  }
`;

export const FIND_CAR_SALE = gql`
  query FindCarSale($id: String!) {
    carSale(id: $id) {
      id
      odometerReading
      dealer {
        id
        name
        streetAddress
        city
        state
        zipCode
        phone
        email
      }
      car {
        id
        make
        model
        year
        vin
      }
      buyer {
        name
        streetAddress
        city
        state
        zipcode
        phone
        email
        county
      }
      recordOfSaleNumber
      soldPrice
      docPrepFee
      smogFee
      salesTaxRate
      salesTaxCharge
      priorCreditToSeller
      publicFees {
        vehicleLicenseFee
        registerTransferTitleFee
        tireFee
        subTotal
        totalDownPayment
        amountFinanced
        balance
      }
      tradeInVehicles {
        year
        make
        model
        vin
        odo
        agreedVal
        buyerRetainedEquity
        agreedValMinorsbuyerRetain
        priorCreditOrLeaseBal
        netTradeIn
      }
      cancellationPlan
      cancellationFee
      cancellationDate
      cancellationReason
      paymentSchedule {
        paymentType
        startDate
        annualPercentageRate
        financeCharge
        amountFinanced
        totalOfPayments
        totalSalePrice
        firstPaymentDate
        finalPaymentDate
        monthlyPaymentAmount
        finalPaymentAmount
        hasSecurityInterest
        lateChargeRate
      }
      paymentDetails {
        cashPriceVehicleNAccessories {
          amount
          cashPriceVehicle
          cashPriceAccessories
          other {
            amount
          }
        }
        docFee
        smogFee
        theftDeterrentDevices {
          paidTo
          amount
        }
        surfaceProtectDevices {
          paidTo
          amount
        }
        evChargingStation {
          paidTo
          amount
        }
        salesTaxRate
        salesTax
        evTransferFee {
          paidTo
          amount
        }
        serviceContacts {
          paidTo
          amount
        }
        priorCreditBySeller {
          paidTo
          amount
        }
        debtCancellationAgreement
        usedVehicleContractCancellationOption
        others {
          paidTo
          amount
          for
        }
        totalCashPrice
        amtPaidToPublicOfficials {
          vehicleLicenseFee
          registerNTransferFee
          caTireFee
          others {
            paidTo
            amount
            for
          }
          totalOfficialFee
        }
        amtPaidToInsuranceComp
        stateEmissionsCertFee
        stateEmissionExemptionFee
        totalDownPayment {
          totalTradeInVal
          vehicleOneVal
          vehicleTwoVal
          totalLessPriorCreditOrLeaseBalance
          vehicleOneCredit
          vehicleTwoCredit
          totalNetTradeInBal
          vehicleOneBal
          vehicleTwoBal
          deferredDownPayableToSeller
          manufactureRebate
          others {
            paidTo
            amount
            for
          }
          cashEquivalent
          totalDownPayment
        }
        amountFinanced
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_CAR_SALE = gql`
  mutation UpdateCarSale($input: UpdateCarSaleInput!) {
    updateCarSale(updateCarSaleInput: $input) {
      id
      paymentDetails {
        cashPriceVehicleNAccessories {
          amount
          cashPriceVehicle
          cashPriceAccessories
          other {
            amount
          }
        }
        docFee
        smogFee
        theftDeterrentDevices {
          paidTo
          amount
        }
        surfaceProtectDevices {
          paidTo
          amount
        }
        evChargingStation {
          paidTo
          amount
        }
        salesTaxRate
        salesTax
        evTransferFee {
          paidTo
          amount
        }
        serviceContacts {
          paidTo
          amount
        }
        priorCreditBySeller {
          paidTo
          amount
        }
        debtCancellationAgreement
        usedVehicleContractCancellationOption
        others {
          paidTo
          amount
          for
        }
        totalCashPrice
        amtPaidToPublicOfficials {
          vehicleLicenseFee
          registerNTransferFee
          caTireFee
          others {
            paidTo
            amount
            for
          }
          totalOfficialFee
        }
        amtPaidToInsuranceComp
        stateEmissionsCertFee
        stateEmissionExemptionFee
        totalDownPayment {
          totalTradeInVal
          vehicleOneVal
          vehicleTwoVal
          totalLessPriorCreditOrLeaseBalance
          vehicleOneCredit
          vehicleTwoCredit
          totalNetTradeInBal
          vehicleOneBal
          vehicleTwoBal
          deferredDownPayableToSeller
          manufactureRebate
          others {
            paidTo
            amount
            for
          }
          cashEquivalent
          totalDownPayment
        }
        amountFinanced
      }
      dealer {
        id
        name
        streetAddress
        city
        state
        zipCode
        phone
        email
      }
      car {
        id
        make
        model
        year
        vin
      }
      buyer {
        name
        streetAddress
        city
        state
        zipcode
        phone
        email
        county
      }
      recordOfSaleNumber
      soldPrice
      docPrepFee
      smogFee
      salesTaxRate
      salesTaxCharge
      priorCreditToSeller
      publicFees {
        vehicleLicenseFee
        registerTransferTitleFee
        tireFee
        subTotal
        totalDownPayment
        amountFinanced
        balance
      }
      tradeInVehicles {
        year
        make
        model
        vin
        odo
        agreedVal
        buyerRetainedEquity
        agreedValMinorsbuyerRetain
        priorCreditOrLeaseBal
        netTradeIn
      }
      cancellationPlan
      cancellationFee
      cancellationDate
      cancellationReason
      paymentSchedule {
        paymentType
        startDate
        annualPercentageRate
        financeCharge
        amountFinanced
        totalOfPayments
        totalSalePrice
        firstPaymentDate
        finalPaymentDate
        monthlyPaymentAmount
        finalPaymentAmount
        hasSecurityInterest
        lateChargeRate
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_SPECIFIC_DEALER_AGREEMENTS = gql`
  query DealerCarSales($dealerId: String!) {
    dealerCarSales(dealerId: $dealerId) {
      id
      dealer {
        id
        name
        streetAddress
        city
        state
        zipCode
        phone
        email
      }
      car {
        id
        make
        model
        year
        vin
      }
      buyer {
        name
        streetAddress
        city
        state
        zipcode
        phone
        email
        county
      }
      odometerReading
      recordOfSaleNumber
      soldPrice
      docPrepFee
      smogFee
      salesTaxRate
      publicFees {
        vehicleLicenseFee
        registerTransferTitleFee
        tireFee
        subTotal
        totalDownPayment
        amountFinanced
        balance
      }
      tradeInVehicles {
        year
        make
        model
        vin
        odo
        agreedVal
        buyerRetainedEquity
        agreedValMinorsbuyerRetain
        priorCreditOrLeaseBal
        netTradeIn
      }
      cancellationPlan
      soldOn
      createdAt
      updatedAt
    }
  }
`;
